// extracted by mini-css-extract-plugin
export default {"content":"OnboardingPage_content__XsdAQ","headline":"OnboardingPage_headline__BVg4e","tooltip":"OnboardingPage_tooltip__BQdVn"};